<template>
  <div class="custom-table-container" style="height: 100%">
    <div class="default-table">
      <div style="margin-bottom: 50px">
        <el-table ref="elAdTable" :data="dataList"
                  v-loading="loadingStatus"
                  element-loading-text="玩命加载中……"
                  element-loading-spinner="el-icon-loading"
                  @select-all="HandleSelectAll"
                  @sort-change="changeTableSort"
                  @selection-change="handleSelectionChange"
                  @select="handleSelectRow"
                  highlight-current-row stripe border>
          <el-table-column type="selection" width="55"/>
          <el-table-column width="60" label="序号">
            <template slot-scope="scope">
              <span>{{ offset + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="customer_name"
              label="客户名称"
              header-align="center"
              align="left"
              width="240"
              :show-overflow-tooltip="true"
              sortable="custom"
          >
            <template slot-scope="scope">
              <template v-if="readonly">
                {{ scope.row.customer_name }}
              </template>
              <template v-else>
                <el-link class="table-link" type="primary" @click="goDetail(scope.row)">
                  <span class="flag-span" style="background-color: #FF5722;"
                        v-show="scope.row.order_type === 'strike' || scope.row.order_type === '冲账类型'">冲</span>
                  <span class="flag-span" style="background-color: #bd06c5;"
                        v-show="scope.row.is_new_customer === 'Y'">新客</span>
                  <span v-show="scope.row.is_mark==1" class="flag-span"
                        style="background-color: #ff3176;">全案  {{
                      scope.row.pid === 0 ? '主' : '子'
                    }}
                  </span>
                  <span v-show="scope.row.project_type==3" class="flag-span"
                        style="background-color: #ff3176;">普客 子
                  </span>
                  <span>{{ scope.row.customer_name }}</span>
                </el-link>
              </template>
            </template>
          </el-table-column>
          <el-table-column
              v-for="(v,k) in columns"
              :key="k"
              :prop="v.field?v.field:typeof(v.value)=='string'?v.value:''"
              :label="v.title"
              :min-width="v.width"
              :show-overflow-tooltip="true"
              :header-align="v.header_align?v.header_align:'left'"
              :align="v.align?v.align:'left'"
              :sortable="v.sortable?v.sortable:false">
            <template slot-scope="scope">
              <template v-if="v.custom==='link_user'">
                <!--        用户链接        -->
                <link-user v-if="scope.row[v.value]" :id="scope.row[v.link_user_id_column]"
                           :name="scope.row[v.value]"/>
              </template>
              <template v-else>
                <span v-if="typeof(v.value)=='string'">
                  <span v-if="v.type == 'image'">
                    <img :src="scope.row[v.value]" :alt="scope.row[v.value]" width="40px">
                  </span>
                  <span v-else-if="v.value_alias">
                    <el-tooltip effect="dark" :content="scope.row[v.value_alias]" placement="top-start"
                                popper-class="ape-table-tooltip" v-if="scope.row[v.value]">
                      <span v-html="scope.row[v.value]"></span>
                    </el-tooltip>
                     <span v-else v-html="scope.row[v.value_alias]"></span>
                  </span>
                  <span v-else v-html="scope.row[v.value]"></span>
                </span>
                <span v-else-if="typeof(v.value)=='object'">
                  <span v-for="(v1,k1) in v.value" :key="k1">
                    <template v-if="v.key">
                      <template v-for="(item, idx) in scope.row[v.key]">
                        <el-tooltip :key="idx" effect="dark" placement="top-start">
                          <div slot="content" v-html="item[v1.value_alias]"></div>
                          <p class="is-value">{{ item[v1.value] }}</p>
                        </el-tooltip>
                      </template>
                    </template>
                    <span class="more-info-display"
                          v-else-if="scope.row[v1.value] || scope.row[v1.value_alias] || scope.row[v1]">
                      <span class="is-value" v-if="typeof(v1)=='string'" v-html="scope.row[v1]"></span>
                      <span class="is-label" v-if="typeof(v1)=='object' && v1.label"
                            :style="{width:v1.width?parseInt(v1.width)+'px':'72px'}" v-html="v1.label"></span>
                      <template v-if="v1.value_alias && v1.value">
                        <el-tooltip effect="dark" placement="top-start" popper-class="ape-table-tooltip"
                                    v-if="scope.row[v1.value]">
                          <div slot="content" v-html="scope.row[v1.value_alias]"></div>
                          <span class="is-value" v-if="typeof(v1)=='object'" v-html="scope.row[v1.value]"></span>
                        </el-tooltip>
                        <span class="is-value" v-else v-html="scope.row[v1.value_alias]"></span>
                      </template>
                      <template v-else>
                        <span class="is-value" v-if="typeof(v1)=='object'" v-html="scope.row[v1.value]"></span>
                      </template>
                    </span>
                  </span>
                </span>
              </template>
            </template>
          </el-table-column>
          <el-table-column
              v-if="hasOptColumn&&needOperate"
              key="操作项"
              label="操作项"
              header-align="center"
              align="left"
              width="160"
              fixed="right"
          >
            <template slot-scope="scope">
              <AdOptColumn :row="scope.row" :row-index="scope.$index" :pt="pt"
                           @refreshOrderList="refreshOrderList"
                           @goDetail="goDetail"
                           @goView="goView"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-footer">
        <el-row>
          <el-col :span="12">
            <div class="bottom-bar">
              <el-button size="mini" @click="clearData" :disabled="previewOrderTotal===0">清空已选
              </el-button>
              <div
                  style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center;">
                <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总含税收入：<span class="money" style="font-size: 1.2rem">{{
                      moneyFormat(paymentAccountTotal)
                    }}</span></span>
                  <span style="margin-right: 10px">总广告收入：<span class="money"
                                                                    style="font-size: 1.2rem">{{
                      moneyFormat(advRevenueTotal)
                    }}</span></span>
                  <span style="margin-right: 10px">已选订单数：<span
                      style="font-size: 1.2rem;color:#ff3176 ">{{
                      previewOrderTotal
                    }} </span>条</span>
                  <span style="margin-right: 10px">平均含税收入：<span class="money"
                                                                      style="font-size: 1.2rem">{{
                      moneyFormat(previewOrderTotal > 0 ? paymentAccountTotal / previewOrderTotal : '--')
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <Pagination :total="pagingData.total" :limit.sync="pagingData.page_size"
                        :page.sync="pagingData.current_page" @pagination="initList"></Pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import {queryOrdersList} from "@/api/adOrder";
import {getTableCols} from "@/api/cache";
import AdOptColumn from "@/views/adOrder/components/AdOptColumn";
import LinkUser from "@/components/LinkUser/index.vue";
import {filterSearchCondition} from "@/views/adOrder";

export default {
  name: "AdOrderTable",
  components: {
    LinkUser,
    AdOptColumn,
  },
  props: {
    readonly: Boolean,
    selectedData: {
      type: Array,
      default() {
        return []
      }
    },
    needOperate: {
      type: Boolean,
      default() {
        return true
      }
    },
    queryParams: {
      type: Object
    },
    height: {type: [String, Number], default: "100%"},
    pt: Number,
  },
  computed: {
    searchCondition: {
      get() {
        return this.queryParams
      },
      set(val) {
        this.$emit('queryParams', val)
      }
    },
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    // //计算总含税收入
    paymentAccountTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.payment_account / 1
      })
      return total
    },
    previewOrderTotal() {
      return this.selectedData.length
    },
    // 总广告收入
    advRevenueTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.adv_revenue / 1
      })
      return total
    },
    hasOptColumn() {
      if (this.readonly) {
        return false
      }
      return this.userAuth.can_exec_adv_order || this.userAuth.strike_balance_but || this.userAuth.option_delete_adv_order || this.userAuth.option_undo_adv_order || this.userAuth.can_create_adv_order || this.userAuth.can_update_adv_order;
    }
  },
  created() {
    this.getTableThead()
  },
  mounted() {
    // this.initList()
  },
  data() {
    return {
      tableRef: 'elAdTable',
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        current_page: 1,
        // offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      columns: [],
      columnsExclude: ['customer_name'],//循环排除，特定样式
      loadingStatus: false,
      // searchCondition: {},
    }
  },
  watch: {
    searchCondition: {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.initList()
        })
      }
    }
  },
  methods: {
    changeTableSort({prop, order}) {
      switch (prop) {
        case "combine_brand_name":
          prop = "combine_brand_id";
          break;
        case 'customer_name':
          prop = "customer_id";
          break;
        default:
          break;
      }
      this.searchCondition.orderBy = {
        field: prop,
        direction: `${order === 'descending' ? 'desc' : 'asc'}`
      }
      this.initList()
    },
    clearData() {
      this.$emit('clearData')
    },
    //清空选中
    handleClearSelection() {
      this.$refs[this.tableRef].clearSelection()
    },
    // 渲染选中
    toggleSelection() {
      const data = this.dataList ? this.dataList : [];
      this.$nextTick(function () {
        data.forEach(row => {
          if (this.selectedData.findIndex(value => value.id === row.id) > -1) {
            this.switchRowSelection(row, true)
          }
        });
      });
    },
    switchRowSelection(row, bool) {
      this.$refs[this.tableRef].toggleRowSelection(row, bool)
    },
    //当选择项发生变化时会触发该事件
    HandleSelectAll(selection) {
      // console.log(selection)
      if (selection.length === 0) {
        //取消全选
        // console.log('取消全选')
        // 取消的数据对象 dataList
        this.dataList.forEach((row) => {
          let index = this.selectedData.findIndex(value => value.id === row.id)
          if (index > -1)
            this.selectedData.splice(index, 1)
        })

      }
    },
    // // 行选中、取消选中
    handleSelectRow(selection, row) {
      // console.log('行选中、取消选中:'+row.id)
      if (selection.indexOf(row) === -1) {
        //row 取消选中
        // console.log('取消选中')
        let index = this.selectedData.findIndex(value => value.id === row.id)
        // this.$notify.info(`取消第${index}行`)
        if (index > -1)
          this.selectedData.splice(index, 1)
      }
    },
    handleCancelSelect(row) {
      let index = this.selectedData.findIndex(value => value.id === row.id)
      // this.$notify.info(`取消第${index}行`)
      if (index > -1) {
        let tbRow = this.dataList.find(value => value.id === row.id)
        this.switchRowSelection(tbRow, false)
        this.selectedData.splice(index, 1)
      }
    },

    init() {
      this.initList()
    },
    // 勾选事件
    handleSelectionChange(selection) {
      this.selectList = selection
      this.$emit('handleSelectionChange', selection)
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2)
    },
    // 处理搜索条件
    handleSearchCondition() {
      return filterSearchCondition(this.searchCondition)
    },
    async initList() {
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, {page: this.pagingData.current_page, per_page: this.pagingData.page_size})
      this.loadingStatus = true
      const {success, model} = await queryOrdersList(searchCondition);
      this.loadingStatus = false
      if (!success) {
        return;
      }
      const {data, total, current_page, per_page} = model
      // this.$nextTick(() => {
      this.dataList = data
      this.toggleSelection()
      // })
      this.pagingData.total = total
      this.offset = (current_page - 1) * per_page
    },
    //表头
    async getTableThead() {
      const linkUserColumns = ['sale_name', 'executor_name', 'medium_name']
      this.columns = [];
      //读取缓存列
      let cacheColumns = localStorage.getItem('ad-columns')
      if (cacheColumns) {
        this.columns = JSON.parse(cacheColumns);
      }
      let {tableCols} = await getTableCols({type: 'ad_order', sort: true}).then((res) => {
        return res.model
      })
      let currentColumns = [];
      tableCols.forEach((item) => {
        //要显示并且不是固定字段 item.display &&
        if (item.display) {
          if (this.columnsExclude.indexOf(item.name) === -1) {
            const obj = {
              title: item.title,
              value: item.name,
              width: item.min_width || 120,
              header_align: item.header_align || 'center',
              align: item.align || 'center',
              sortable: item.sortable || false,
              field: item.field || item.name,
              custom: false
            }
            if (linkUserColumns.indexOf(item.name) !== -1) {
              const tmp_array = item.name.split('_')
              obj.custom = 'link_user'
              obj.link_user_id_column = (tmp_array[0] || '') + '_id'
            }
            currentColumns.push(obj)
          }
        }
      })

      this.columns = currentColumns;
      localStorage.setItem('ad-columns', JSON.stringify(currentColumns))
      this.$emit('tableColumns', this.columns)

    },
    refreshOrderList() {
      this.$emit('refreshOrderList')
    },
    goView(row) {
      this.$emit('goDetail', row)
    },
    goDetail(row) {
      this.$emit('goDetail', row)
    },
  }
}
</script>

<style scoped>
.page-footer {
  height: 50px;
  width: 100%;
  position: fixed;
  bottom: 1px;
  background-color: #FFFFFF;
  opacity: 0.9;
  z-index: 999;
}

.bottom-bar {
  width: 100%;
  /*margin-top: 10px;*/
  text-align: left !important;
  padding: 10px 10px 0 1px;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  /*position: fixed;bottom: 1px;*/
  /*background: #FFFFFF;*/
  /*z-index: 99999;*/
  /*opacity: 0.75;*/
}


</style>

<style lang="scss">
.table-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .el-link--inner {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    span:last-child {
      margin-left: 2px;
    }
  }

  .flag-span {
    color: #FFF !important;
    padding: 2px 4px;
    border-radius: 2px;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    line-height: 1;
  }

  .flag-span + .flag-span {
    margin-left: 2px;
  }


}
</style>
